import api from '@/api';
import { saveAs } from '@/utils/file-saver';

export const downloadXls = params => {
  api.doBlobPostParkingRequest(`/report/efs`, { ...params }).then(response => {
    saveAs(response.data, `Отчет EFS.xlsx`);
  });
};
